export const API_URL = 'https://launchpad-backend.games-feed.workers.dev'
//export const API_URL = 'http://localhost:8787'
